var layoutype = 'seven';
var _iub = _iub || {};
var quickModal = undefined;
setIubenda();

$(document).ready(function () {
  filterModal();
  breadcrumbObserver();
  getLayout();
  countrySelector();
  header();
  openMenu({
    container: '#megamenu-container',
    trigger: {
      element: '[data-megamenu]',
      event: 'mouseover',
      attribute: 'data-megamenu'
    },
    prefix: 'megamenu',
    menu: menuData.desktop,
    top: 'body',
    class: 'megamenu-open',
    untrigger: { element: '.megamenu', event: 'mouseleave' }
  });
  openMenu({
    container: '#minimenu-accordion',
    trigger: {
      element: '[data-minimenu-second]',
      event: 'click',
      attribute: 'data-minimenu-second'
    },
    prefix: 'minimenu',
    menu: menuData.mobile,
    top: '#minimenu',
    class: 'second-open',
    untrigger: { element: '[data-minimenu-back]', event: 'click' },
    title: '#second-menu-title'
  });
  forms();
  //listener triggers only if fallback library is needed, to reinitialize the sliders
  document.addEventListener('library-loaded', () => {
    sliders();
  });
  sliders();
  videoSection();
  productCard();
  quickview();
  automodals();
  ictcart();
  cart();
  totalook();
  compare();
  collection();
  newAddress();
  checkCountry();
  popup();
});

function getLayout() {
  if (getCookie('layoutype') !== undefined) {
    layoutype = 'sj';
    $('html').addClass('sj');
  } else {
    layoutype = 'seven';
    $('html').removeClass('sj');
  }
}

function countrySelector() {
  $('[data-country-change]').on('click', function () {
    var id = $(this).attr('data-country-input');
    $(id).val($(this).attr('data-country-change'));
    $(this).parents('form').submit();
  });
}

function header() {
  initBottomMenuLogoWidth();
  stickyHeader();
  getHeaderHeight();
  setMenuTop();

  $(window).on('scroll', stickyHeader);
  $(window).on('scroll', setMenuTop);
  $(window).on('resize', getHeaderHeight);

  var selectors = {
    minimenu: '#minimenu',
    minimenuBtn: '[data-minimenu]',
    searchMobile: {
      input: '#search-input-mobile',
      form: '#search-form-mobile',
      textResult: '#search-text-result',
      noneResult: '#search-none',
      productResult: '#search-product-result',
      results: '#search-results-dropdown-mobile',
      btn: '[data-search-mobile]',
      pages: '[data-search-pages]',
      products: '[data-search-products]',
      suggestions: '[data-search-suggestions]',
      collections: '[data-search-collections]'
    },
    searchDesktop: {
      input: '#search-input',
      form: '#search-form',
      textResult: '#search-text-result',
      noneResult: '#search-none',
      productResult: '#search-product-result',
      results: '#search-results-dropdown',
      btn: '[data-search-btn]',
      pages: '[data-search-pages]',
      products: '[data-search-products]',
      suggestions: '[data-search-suggestions]',
      collections: '[data-search-collections]'
    }
  };
  var key = '';

  function getHeaderHeight() {
    const siteHeader = document.querySelector('#shopify-section-header');

    siteHeader.style.setProperty(
      '--header-height',
      `${siteHeader.offsetHeight}px`
    );
  }

  function setMenuTop () {
    const announcementBar = document
      .querySelector('#shopify-section-announcement');
    const menuTop = announcementBar.scrollHeight - window.scrollY;

    document.querySelector('#shopify-section-header')
      .style.setProperty(
        '--announcement-bar-height',
        `${menuTop >= 0 ? menuTop : 0}px`
      );
  }

  function initBottomMenuLogoWidth() {
    let bottomMenuLogoWidth = 0;
    $('.bottom-menu .site-logo').each(function () {
      bottomMenuLogoWidth += $(this).width() + 42;
    });
    $('.bottom-menu .nav').attr(
      'style',
      '--bottom-menu-logo-width:' + bottomMenuLogoWidth + 'px'
    );
  }

  function stickyHeader() {
    const configEl = document.querySelector('#logo-menu-hide');
    const configData = configEl ? JSON.parse(configEl.innerText) : false;

    if (!configData || !configData.enable) {
      var totalh =
        $('#shopify-section-announcement').height() +
        $('#site-header').height();
      if ($(window).scrollTop() > totalh) {
        $('body').addClass('sticky-header');
      } else {
        $('body').removeClass('sticky-header');
      }
    }

    const threshold =
      window.innerWidth > 992
        ? configData.threshold
        : configData.threshold_mobile;

    if ($(window).scrollTop() > threshold) {
      $('body').addClass('sticky-header');
    } else {
      $('body').removeClass('sticky-header');
    }
  }

  if ($(selectors.searchDesktop.form).length) {
    $(selectors.searchDesktop.btn).on('click', function () {
      $('.top-menu').toggleClass('search-form');
    });
    initSearch(selectors.searchDesktop);
  }
  if ($(selectors.searchMobile.form).length) {
    $(selectors.searchMobile.btn).on('click', function () {
      $('body').toggleClass('search-form');
    });
    initSearch(selectors.searchMobile);
  }

  if ($(selectors.minimenu).length) {
    $(selectors.minimenuBtn).on('click', function () {
      $('body').toggleClass('minimenu-open');
    });
  }

  function initSearch(s) {
    var suggestions = $(s.form).find(s.suggestions);
    var collections = $(s.form).find(s.collections);
    var pages = $(s.form).find(s.pages);
    var products = $(s.form).find(s.products);

    $(s.input).on('keyup', function () {
      search($(this).val());
    });

    function search(key) {
      if (key.length > 0 && key != undefined) {
        $.ajax({
          type: 'GET',
          url: '/search/suggest.json',
          data: {
            q: key,
            resources: {
              type: 'product,collection,page'
            }
          },
          contentType: 'application/json',
          dataType: 'json',
          success: function (data) {
            showResult(
              data.resources.results.collections,
              collections,
              $(s.textResult).html(),
              3
            );
            showResult(
              data.resources.results.pages,
              pages,
              $(s.textResult).html(),
              3
            );
            showResult(
              data.resources.results.products,
              suggestions,
              $(s.textResult).html(),
              3
            );
            showResult(
              data.resources.results.products,
              products,
              $(s.productResult).html()
            );
            $(s.results).removeClass('d-none');
          },
          error: function (error) {
            console.log(error);
          }
        });
      } else {
        $(s.results).addClass('d-none');
      }
    }

    function showResult(results, container, template, limit) {
      var max = limit > 0 ? limit : results.length;
      if (results.length > 0) {
        $(container).html('');
        for (var i = 0; i < max; i++) {
          var result = results[i];
          if (result != undefined) {
            var title = result.title.replace(
              key,
              '<span class="bold">' + key + '</span>'
            );
            var html = template
              .replaceAll('{url}', result.url)
              .replaceAll('{title}', title)
              .replaceAll('{img}', result.image)
              .replaceAll('{price}', result.price)
              .replaceAll('{active}', result.active)
              .replaceAll('{childActive}', result.childActive);
            $(container).append(html);
          }
        }
      } else {
        var none = $(s.noneResult).html();
        $(container).html(none);
      }
    }
  }
}

function openMenu(options) {
  if (($(options.container).length = 0)) {
    console.log('no container');
    return;
  }

  var tree = layoutype == 'seven' ? menuData.primary : menuData.secondary;
  $(options.trigger.element).on(options.trigger.event, function () {
    if ($('body').hasClass('block-menu') && window.innerWidth > 992) {
      return;
    }

    $(options.container).html('');
    var id = $(this).attr(options.trigger.attribute);
    $(tree).each(function () {
      if (id == options.prefix + this.id) {
        if ($(options.title).length) {
          $(options.title).html(this.title);
        }
        var html = [];
        $(this.links).each(function () {
          var list = [];
          var second = options.menu.second;
          var third = options.menu.third;
          if (this.links.length > 0) second = options.menu.second_links;
          $(this.links).each(function () {
            if (this.image != undefined) {
              second = options.menu.second_images;
              third = options.menu.third_image;
            }
          });

          $(this.links).each(function () {
            list[list.length] = third
              .replaceAll('{title}', this.title)
              .replaceAll('{url}', this.url)
              .replaceAll('{image}', this.image)
              .replaceAll('{id}', this.id)
              .replaceAll('{active}', this.active)
              .replaceAll('{childActive}', this.childActive);
          });
          html[html.length] = second
            .replaceAll('{title}', this.title)
            .replaceAll('{url}', this.url)
            .replaceAll('{links}', list.join(''))
            .replaceAll('{id}', this.id)
            .replaceAll('{active}', this.active)
            .replaceAll('{childActive}', this.childActive);
        });
        $(options.container).html(html.join(''));
      }
    });
    $(options.top).addClass(options.class);
  });
  $(options.untrigger.element).on(options.untrigger.event, function () {
    $(options.container).html('');
    $(options.top).removeClass(options.class);
  });
}

function forms() {
  $('form').each(function () {
    if ($(this).attr('data-no-ajax') == undefined) {
      thisform(this);
    }
  });
}

function thisform(form, callback) {
  $(form)
    .find('[data-form-autosubmit]')
    .on('change', function () {
      submitForm();
    });
  $(form)
    .find('[data-form-submit]')
    .on('click', function () {
      submitForm();
    });
  $(form)
    .find('input,textarea,select')
    .on('blur', function () {
      validateInput(this);
    });
  $(form)
    .find('input,textarea,select')
    .on('focus', function () {
      setError(this, true);
    });

  function submitForm() {
    if (validate()) {
      if (callback == null || callback == undefined) {
        if ($(form).find('[data-form-privacy]').length) {
          setConsent();
        } else {
          form.submit();
        }
      } else {
        callback();
      }
    }
  }

  function validate() {
    var valid = true;
    $(form)
      .find('input,textarea,select')
      .each(function () {
        var v = validateInput(this);
        valid = valid ? v : valid;
      });
    return valid;
  }

  function validateInput(input) {
    var v = true;
    if ($(input).attr('type') == 'checkbox') v = validateCheckbox(input);
    else if ($(input).attr('type') == 'hidden') v = true;
    else v = validateText(input);
    return v;
  }

  function validateCheckbox(input) {
    var valid = true;
    var msg = '';
    if ($(input).attr('required') != undefined && !$(input).is(':checked')) {
      msg = window.formErrors.required;
      valid = false;
    }
    setError(input, valid, msg);
    return valid;
  }

  function validateText(input) {
    var val = $(input).val();
    var valid = false;
    var msg = '';
    if (val == undefined || val == null || val.length <= 0) {
      if ($(input).attr('required') != undefined)
        msg = window.formErrors.required;
      else valid = true;
    } else {
      if ($(input).attr('type') == 'email' && !isEmail(val))
        msg = window.formErrors.email;
      else if (
        $(input).attr('data-form-newpassword') != undefined &&
        !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(val)
      )
        msg = window.formErrors.newpassword;
      else if (
        $(input).attr('data-form-equals') != undefined &&
        val.localeCompare($($(input).attr('data-form-equals')).val()) !== 0
      )
        msg = window.formErrors.equals;
      else if (
        $(input).attr('minlength') != undefined &&
        val.length < parseInt($(input).attr('minlength'))
      )
        msg = window.formErrors.min_chars.replace(
          '{{number}}',
          $(input).attr('minlength')
        );
      else if (
        $(input).attr('data-maxlength') != undefined &&
        val.length > parseInt($(input).attr('data-maxlength'))
      )
        msg = window.formErrors.max_chars.replace(
          '{{number}}',
          $(input).attr('data-maxlength')
        );
      else valid = true;
    }
    setError(input, valid, msg);
    return valid;
  }

  function setError(input, valid, msg) {
    if (!valid) {
      $(input).parents('[data-form-parent]').addClass('form-invalid');
      $(input)
        .parents('[data-form-parent]')
        .find('.invalid-feedback')
        .text(msg);
    } else {
      $(input).parents('[data-form-parent]').removeClass('form-invalid');
      $(input).parents('[data-form-parent]').find('.invalid-feedback').text('');
    }
  }

  function setConsent() {
    _iub.cons_instructions.push([
      'submit',
      {
        form: {
          selector: form
        },
        consent: {
          legal_notices: [
            {
              identifier: 'term',
              version: '1'
            }
          ]
        }
      },
      {
        success: function (response) {
          form.submit();
          console.log(response);
        },
        error: function (response) {
          console.log(response);
        }
      }
    ]);
  }
}

function sliders() {
  var blocksSliderSelector = '.blocks-slider .swiper';
  var collectionCarouselSelector = '.collection-carousel .swiper';
  var featuredCarouselSelector = '.featured-carousel .swiper';
  var productSelector = '#main-product .swiper';

  $(blocksSliderSelector).each(function () {
    var opt = {
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    };
    if ($(this).attr('data-autoplay-seconds') != undefined) {
      var s = $(this).attr('data-autoplay-seconds') * 1000;
      opt.autoplay = {
        delay: s,
        disableOnInteraction: true
      };
    }
    var swiper = new Swiper(this, opt);
  });

  $(collectionCarouselSelector).each(function () {
    const spaceBetween = $(this).attr('data-space-between') || '5';
    const slidesPerViewMobile =
      $(this).attr('data-slides-per-view-mobile') || '2';
    const slidesPerView768 = $(this).attr('data-slides-per-view-768') || '3';
    const slidesPerView1200 = $(this).attr('data-slides-per-view-1200') || '4';
    const slidesPerView1440 = $(this).attr('data-slides-per-view-1440') || '5';

    new Swiper(this, {
      slidesPerView: parseInt(slidesPerViewMobile),
      spaceBetween: parseInt(spaceBetween),
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: parseInt(slidesPerView768)
        },
        1200: {
          slidesPerView: parseInt(slidesPerView1200)
        },
        1440: {
          slidesPerView: parseInt(slidesPerView1440)
        }
      }
    });
  });

  $(featuredCarouselSelector).each(function () {
    const spaceBetween = $(this).attr('data-space-between') || '5';
    const slidesPerViewMobile =
      $(this).attr('data-slides-per-view-mobile') || '2';
    const slidesPerView768 = $(this).attr('data-slides-per-view-768') || '3';
    const slidesPerView1200 = $(this).attr('data-slides-per-view-1200') || '4';
    const slidesPerView1440 = $(this).attr('data-slides-per-view-1440') || '5';

    var swiper = new Swiper(this, {
      slidesPerView: parseInt(slidesPerViewMobile),
      spaceBetween: parseInt(spaceBetween),
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: parseInt(slidesPerView768)
        },
        1200: {
          slidesPerView: parseInt(slidesPerView1200)
        },
        1440: {
          slidesPerView: parseInt(slidesPerView1440)
        }
      }
    });
  });

  $(productSelector).each(function () {
    var swiper = new Swiper(this, {
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  });
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function deleteCookie(name) {
  var date = new Date();
  date.setTime(0);
  document.cookie = name + '=' + date.toUTCString() + '; path=/';
}

function videoSection() {
  $('.video-section .play').on('click', function () {
    if ($('.video-section iframe').length) {
      var url = new URL($('.video-section iframe').attr('src'));
      url.searchParams.set('autoplay', '1');
      $('.video-section iframe').attr('src', url);
      $('.video-section .play').remove();
    } else if ($('.video-section video').length) {
      $('.video-section video').trigger('play');
      $('.video-section .play').remove();
    }
  });
}

function productCard() {
  $('[data-swatch-url]')
    .off()
    .on('click', function () {
      var prod = $(this).parents('.product-card');
      var url = $(this).attr('data-swatch-url');
      var img = $(this).attr('data-swatch-img');
      var price = parseInt($(this).attr('data-swatch-price'));
      var priceF = $(this).attr('data-swatch-price-format');
      var compare = parseInt($(this).attr('data-swatch-compare'));
      var compareF = $(this).attr('data-swatch-compare-format');
      var id = $(this).attr('data-swatch-id');
      var hover = $(this).attr('data-swatch-hover');

      $(prod).find('[data-product-url]').attr('href', url);
      $(prod).find('[data-product-image]').attr('src', img);
      $(prod).find('[data-product-price]').text(priceF);
      $(prod).find('[data-product-compare]').text(compareF);
      $(prod)
        .find('[data-quickview-variant]')
        .attr('data-quickview-variant', id);
      if (price < compare) {
        var percentage = 100 - (price * 100) / compare;
        $(prod).find('[data-product-compare]').removeClass('d-none');
        $(prod).find('[data-product-price]').addClass('text-danger');
        $(prod)
          .find('[data-product-percentage]')
          .removeClass('d-none')
          .text('-' + percentage.toFixed(0) + '%');
      } else {
        $(prod).find('[data-product-compare]').addClass('d-none');
        $(prod).find('[data-product-price]').removeClass('text-danger');
        $(prod).find('[data-product-percentage]').addClass('d-none');
      }
      if (hover != undefined) {
        $(prod).find('[data-product-second]').attr('src', hover);
      }

      $(prod).find('[data-swatch-url]').removeClass('active');
      $(this).addClass('active');
    });

  $('.swatch-add')
    .off()
    .on('click', function () {
      var prod = $(this).parents('.product-card');
      $(prod).find('.swatch').removeClass('d-none');
      $(this).remove();
    });
}

function quickview() {
  if (quickModal == undefined) {
    quickModal = new bootstrap.Modal(document.getElementById('quickview'), {
      keyboard: false
    });
  }

  $('[data-quickview]')
    .off()
    .on('click', function () {
      quickModal.show();
      var handle = $(this).attr('data-quickview');
      var variant = $(this).attr('data-quickview-variant');
      var url = $(this).attr('data-quickview-url');
      showQuickview(handle, variant, url);
    });

  $('#quickview')
    .off()
    .on('hidden.bs.modal', function () {
      $('#quickview-loader').removeClass('d-none');
      $('#quickview-content').addClass('d-none');
    });

  //colorHover();

  function showQuickview(handle, variant, url) {
    $('#quickview-loader').removeClass('d-none');
    $('#quickview-content').addClass('d-none');
    $.ajax({
      type: 'GET',
      url: url + '?handle=' + handle + '&variant=' + variant,
      cache: false,
      contentType: false,
      processData: false,
      success: function (str) {
        $('#quickview-content').html($(str).find('#quickview-loaded').html());

        var swiper = new Swiper('#quickview-swiper', {
          slidesPerView: 4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });

        $('#quickview-loader').addClass('d-none');
        $('#quickview-content').removeClass('d-none');

        $('[data-quickview-select-variant]').each(function () {
          $(this).on('click', function (e) {
            e.preventDefault();
            var v = $(this).attr('data-quickview-select-variant');
            showQuickview(handle, v, url);
          });
        });

        $('[data-quickview-image]').on('click', function (e) {
          e.preventDefault();
          var src = $(this).find('img').attr('src');
          if (src !== undefined) {
            $('#quickview-image').attr('src', src);
            $('#quickview-image').removeClass('d-none');
            $('#quickview-video').addClass('d-none');
          } else {
            $('#quickview-video').removeClass('d-none');
            $('#quickview-image').addClass('d-none');
          }
          $('#quickview [data-quickview-image]').removeClass('active');
          $(this).addClass('active');
        });
        //colorHover();
        ictcart();
        checkCountry();
      },
      error: function (err) {
        console.log(err);
      }
    });
  }

  function colorHover() {
    $('[data-quickview-name]')
      .off()
      .on('mouseover', function () {
        var name = $(this).attr('data-quickview-name');
        $(this)
          .parents('[data-totalook-option]')
          .find('[data-option-name]')
          .text(name);
      });

    $('[data-totalook-option]')
      .off()
      .on('mouseleave', function () {
        $(this).find('[data-option-name]').text('');
      });
  }
}

function isEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function automodals() {
  $('[data-openmodal]').each(function () {
    var modal = new bootstrap.Modal(this, {
      keyboard: false
    });
    modal.show();
  });
}

function serialize(form) {
  var arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (
      !field.name ||
      field.disabled ||
      ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
    )
      return;
    if (field.type === 'select-multiple') {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push(
          encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(option.value)
        );
      });
      return;
    }
    if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
      return;
    arr.push(
      encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
    );
  });
  return arr.join('&');
}

function cart() {
  var selectors = {
    quantity: '[data-cart-quantity]',
    quantityMinus: '[data-cart-minus]',
    quantityPlus: '[data-cart-plus]',
    item: '[data-cart-parent]',
    quantityParent: '[data-form-parent]',
    giftItem: '[data-cart-gift-product]',
    remove: '[data-cart-remove]',
    quantityInput: '[data-cart-quantity-input]',
    invoice: '#invoice-check',
    invoiceNeeded: '#invoice-needed',
    invoiceType: '#invoice-type',
    invoiceBusinessName: '#invoice-business-name',
    invoiceVat: '#invoice-vat',
    invoiceSdi: '#invoice-sdi',
    invoicePec: '#invoice-pec',
    invoiceTaxCode: '#invoice-tax-code',
    invoiceTypeBusiness: '#invoice-type-business',
    invoiceTypePrivate: '#invoice-type-private',
    addGift: '#add-gift',
    removeBtn: '[data-cart-remove-btn]',
    submit: '[data-cart-submit]',
    checkout: '#checkout',
    notes: '#checkout-notes'
  };
  var cartUrls = {
    cartAddUrl: '/cart/add',
    cartChangeUrl: '/cart/change',
    cartClearUrl: '/cart/clear'
  };
  var typeBusinessCollapse = undefined;
  var typePrivateCollapse = undefined;
  var invoiceCollapse = undefined;

  if ($('#main-cart').length) {
    init();
  }

  function init() {
    if ($(selectors.quantity).length) {
      $(selectors.quantity)
        .off()
        .on('keyup', function () {
          updateQuantity(this);
        });
    }
    if ($(selectors.quantityMinus).length) {
      $(selectors.quantityMinus)
        .off()
        .on('click', function () {
          removeQuantity(this);
        });
    }
    if ($(selectors.quantityPlus).length) {
      $(selectors.quantityPlus)
        .off()
        .on('click', function () {
          addQuantity(this);
        });
    }
    if ($(selectors.removeBtn).length) {
      $(selectors.removeBtn)
        .off()
        .on('click', function () {
          removeElement(this);
        });
    }
    if ($(selectors.invoice).length) {
      $(selectors.invoice).off().on('change', checkInvoice);
      $(selectors.invoiceType).off().on('change', checkType);
      typeBusinessCollapse = new bootstrap.Collapse(
        $(selectors.invoiceTypeBusiness),
        {
          toggle: false
        }
      );
      typePrivateCollapse = new bootstrap.Collapse(
        $(selectors.invoiceTypePrivate),
        {
          toggle: false
        }
      );
      invoiceCollapse = new bootstrap.Collapse($(selectors.invoiceNeeded), {
        toggle: false
      });
      checkInvoice();
      checkType();
    }
    if ($(selectors.addGift).length) {
      $(selectors.addGift).off().on('change', addGift);
    }

    $(selectors.invoiceSdi).on('change', function () {
      forceFormat(this);
    });

    $(selectors.invoiceTaxCode).on('change', function () {
      forceFormat(this);
    });

    thisform($('#main-cart'), function () {
      getNotes();
      $(selectors.checkout).attr('type', 'submit');
      $(selectors.invoice).off();
      if (!$(selectors.invoice).is(':checked')) {
        $(selectors.invoice).val = 'No';
        $(selectors.invoice).attr('type', 'hidden');
      }
      location.href = '/checkout';
    });
  }

  function forceFormat(input) {
    let tempValue = input.value.toUpperCase().replaceAll(' ', '');
    input.value = tempValue;
  }

  function updateCart(item) {
    var url = $(item).attr('data-cart-remove');
    var num = parseInt($(item).find(selectors.quantityInput).val());
    url = url.replace('quantity=0', 'quantity=' + num);
    $.ajax({
      type: 'GET',
      url: url,
      cache: false,
      success: function () {
        location.reload();
      },
      error: function (error) {
        console.log(error);
      }
    });
  }

  function updateQuantity(element) {
    var num = parseInt($(element).val());
    if (!isNaN(num) && num > 0) {
      updateCart($(element).parents(selectors.item));
    }
  }

  function removeQuantity(element) {
    var input = $(element)
      .parents(selectors.quantityParent)
      .find(selectors.quantity);
    var el = $(element).parents(selectors.item).find(selectors.quantityInput);
    var num = parseInt($(input).val());
    if (!isNaN(num)) {
      num = num - 1;
      if (num > 0) {
        $(input).val(num);
        $(el).val(num);
        updateCart($(element).parents(selectors.item));
      }
    }
  }

  function addQuantity(element) {
    var input = $(element)
      .parents(selectors.quantityParent)
      .find(selectors.quantity);
    var el = $(element).parents(selectors.item).find(selectors.quantityInput);
    var num = parseInt($(input).val());
    if (!isNaN(num)) {
      num = num + 1;
      if (num > 0) {
        $(input).val(num);
        $(el).val(num);
        updateCart($(element).parents(selectors.item));
      }
    }
  }

  function checkInvoice() {
    $(selectors.invoiceBusinessName).removeAttr('required');
    $(selectors.invoiceVat).removeAttr('required');
    $(selectors.invoiceSdi).removeAttr('required');
    $(selectors.invoicePec).removeAttr('required');
    $(selectors.invoiceTaxCode).removeAttr('required');
    $(selectors.invoiceType).removeAttr('required');
    typeBusinessCollapse.hide();
    typePrivateCollapse.hide();

    if ($(selectors.invoice).is(':checked')) {
      $(selectors.invoice).val('Si');
      $(selectors.invoiceType).attr('required', true);
      invoiceCollapse.show();
    } else {
      $(selectors.invoice).val('No');
      $(selectors.invoiceBusinessName).val('');
      $(selectors.invoiceVat).val('');
      $(selectors.invoiceSdi).val('');
      $(selectors.invoicePec).val('');
      $(selectors.invoiceTaxCode).val('');
      $(selectors.invoiceType).val('');
      invoiceCollapse.hide();
    }
  }

  function checkType() {
    var val = $(selectors.invoiceType).find(':selected').attr('data-invoice');
    if (val != undefined) {
      if (val == 0) {
        typeBusinessCollapse.show();
        typePrivateCollapse.hide();
        $(selectors.invoiceTypeBusiness)
          .find('input,select,textarea')
          .attr('required', true);
        $(selectors.invoiceTypePrivate)
          .find('input,select,textarea')
          .removeAttr('required');
        $(selectors.invoiceTypePrivate).find('input,select,textarea').val('');
      } else {
        typePrivateCollapse.show();
        typeBusinessCollapse.hide();
        $(selectors.invoiceTypePrivate)
          .find('input,select,textarea')
          .attr('required', true);
        $(selectors.invoiceTypeBusiness)
          .find('input,select,textarea')
          .removeAttr('required');
        $(selectors.invoiceTypeBusiness).find('input,select,textarea').val('');
      }
    }
  }

  function addGift() {
    if ($(selectors.addGift).is(':checked')) {
      fetch(cartUrls.cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body:
          'id=' +
          $(selectors.addGift).attr('value') +
          '&quantity=1&form_type=product&utf8=✓'
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          location.reload();
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      var url = $(selectors.giftItem).attr('data-cart-remove');
      $.ajax({
        type: 'GET',
        url: url,
        cache: false,
        success: function (data) {
          location.reload();
        },
        error: function (error) {
          console.log(error);
        }
      });
    }
  }

  function removeElement(element) {
    if ($(selectors.giftItem).length > 0 && $(selectors.item).length <= 2) {
      location.href = cartUrls.cartClearUrl;
    } else {
      var url = $(element).parents(selectors.item).attr('data-cart-remove');
      location.href = url;
    }
  }

  function getNotes() {
    var string = '';
    if ($(selectors.invoice).is(':checked')) {
      var val = $(selectors.invoiceType).find(':selected').attr('data-invoice');
      if (val != undefined) {
        if (val == 0) {
          var r = $(selectors.notes).attr('data-business-string');
          var businessName = $(selectors.invoiceBusinessName).val();
          var vat = $(selectors.invoiceVat).val();
          var sdi = $(selectors.invoiceSdi).val();
          var pec = $(selectors.invoicePec).val();
          string = r
            .replace('{business_name}', businessName)
            .replace('{vat}', vat)
            .replace('{sdi}', sdi)
            .replace('{pec}', pec);
        } else {
          var r = $(selectors.notes).attr('data-private-string');
          var cf = $(selectors.invoiceTaxCode).val();
          string = r.replace('{cf}', cf);
        }
      }
    }
    $(selectors.notes).val(string);
  }
}

function totalook() {
  var selectors = {
    item: '[data-totalook-item]',
    input: '[data-totalook-variantid]',
    image: '[data-totalook-mainimg]',
    price: '[data-totalook-price]',
    priceCount: '[data-totalook-pricecount]',
    variant: '[data-totalook-variant]',
    option: '[data-totalook-option]',
    total: '[data-totalook-total]',
    button: '[data-totalook-add]'
  };
  var attributes = {
    input: 'value',
    priceCount: 'value',
    priceVariant: 'data-totalook-variant-count',
    variant: 'data-totalook-variant',
    price: 'data-totalook-variant-price',
    image: 'data-totalook-variant-image'
  };

  $(selectors.variant).on('click', function () {
    changeVariant(this);
  });

  $(selectors.button).on('click', function () {
    addCart();
  });

  $(selectors.input).on('change', function () {
    calcTotal();
  });

  function addCart() {
    var items = [];
    $(selectors.input).each(function () {
      if ($(this).is(':checked')) {
        items[items.length] = {
          quantity: 1,
          id: $(this).attr(attributes.input)
        };
      }
    });
    if (items.length > 0) {
      $.ajax({
        type: 'GET',
        url: '/cart/add.js',
        data: {
          items: items
        },
        cache: false,
        success: function () {
          location.href = '/cart';
        },
        error: function (error) {
          console.log(error);
        }
      });
    }
  }

  function calcTotal() {
    var total = 0;
    $(selectors.item).each(function () {
      if ($(this).find(selectors.input).is(':checked')) {
        total =
          total +
          parseInt(
            $(this).find(selectors.priceCount).attr(attributes.priceCount)
          );
      }
    });
    var price = '€' + (total / 100).toFixed(2).replace('.', ',');
    $(selectors.total).text(price);
  }

  function changeVariant(element) {
    if (!$(element).hasClass('disabled')) {
      var item = $(element).parents(selectors.item);
      var option = $(element).parents(selectors.option);
      var id = $(element).attr(attributes.variant);
      var image = $(element).attr(attributes.image);
      var price = $(element).attr(attributes.price);
      var count = $(element).attr(attributes.priceVariant);
      $(item).find(selectors.input).attr(attributes.input, id);
      $(item).find(selectors.image).attr('src', image);
      $(item).find(selectors.price).text(price);
      $(item).find(selectors.priceCount).attr(attributes.priceCount, count);
      $(option).find(selectors.variant).removeClass('active');
      $(element).addClass('active');
      calcTotal();
    }
  }
}

function compare() {
  var selectors = {
    add: '[data-compare-add]',
    results: '#compare-result',
    content: '#compare-result-content',
    price: '[data-compare-price]',
    variant: '[data-compare-variant]',
    item: '[data-compare-item]',
    cardUrl: '[data-product-url]',
    cardImage: '[data-product-image]',
    cardVariant: '[data-swatch-url]'
  };
  var attributes = {
    add: 'data-compare-add',
    cardUrl: 'data-swatch-url',
    cardPriceCompare: 'data-swatch-compare',
    cardPriceCompareFormat: 'data-swatch-compare-format',
    cardVariant: 'data-swatch-id',
    cardPrice: 'data-swatch-price',
    cardPriceFormat: 'data-swatch-price-format',
    cardImage: 'data-swatch-img',
    item: 'data-compare-item',
    variant: 'data-compare-variant',
    price: 'data-compare-price',
    clear: 'data-clear-url'
  };

  init();

  function init() {
    $(selectors.add)
      .off()
      .on('click', function (e) {
        e.preventDefault();
        addCompare(this);
      });
    $(selectors.cardVariant).on('click', function () {
      changeVariant(this);
    });
  }

  function changeVariant(element) {
    var priceFormat = $(element).attr(attributes.cardPriceFormat);
    var id = $(element).attr(attributes.cardVariant);
    var url = $(element).attr(attributes.cardUrl);
    var image = $(element).attr(attributes.cardImage);
    var item = $(element).parents(selectors.item);

    $(selectors.price).each(function () {
      if (
        $(this)
          .attr(attributes.price)
          .localeCompare($(item).attr(attributes.item)) == 0
      ) {
        $(this).text(priceFormat);
      }
    });

    $(selectors.variant).each(function () {
      if (
        $(this)
          .attr(attributes.variant)
          .localeCompare($(item).attr(attributes.item)) == 0
      ) {
        $(this).attr('value', id);
      }
    });

    $(item).find(selectors.cardUrl).attr('href', url);
    $(item).find(selectors.cardImage).attr('src', image);
    $(item).find('.active').removeClass('active');
    $(element).addClass('active');
  }

  function addCompare(element) {
    var id = $(element).attr(attributes.add);

    $.ajax({
      type: 'GET',
      url: '/cart.js',
      contentType: 'application/json',
      dataType: 'json',
      success: function (data) {
        var compares = data.attributes.compare;
        if (compares != undefined) {
          compares = compares.split(',');
        } else {
          compares = [];
        }
        var add = true;
        var newCompares = [];
        $(compares).each(function () {
          if (this.localeCompare(id) == 0) {
            add = false;
          } else if (
            this.length > 0 &&
            this != undefined &&
            this != null &&
            this != ''
          ) {
            newCompares[newCompares.length] = this;
          }
        });
        if (add) {
          newCompares[newCompares.length] = id;
        }
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          dataType: 'json',
          data: {
            attributes: {
              compare: newCompares.join(',')
            }
          },
          cache: false,
          success: function (data) {
            if ($(element).attr(attributes.clear) != undefined) {
              console.log(window.location.origin + window.location.pathname);
              location.href = window.location.origin + window.location.pathname;
            } else {
              location.reload();
            }
          },
          error: function (error) {
            console.log(error);
          }
        });
      },
      error: function (error) {
        console.log(error);
      }
    });
  }
}

function collection() {
  var selectors = {
    sort: '[data-sort]',
    sortSelect: '[data-sort-select]',
    filterOpen: '[data-filters-open]',
    filterCheck: '[data-filters-input]',
    viewMin: '[data-collection-grid-min]',
    viewMax: '[data-collection-grid-max]',
    gridItem: '[data-collection-grid-item]',
    container: '[data-grid-container]',
    btnLoad: '[data-load-btn]',
    slider: '#slider',
    sliderValue: '#slider-value'
  };
  var attributes = {
    sort: 'data-sort',
    breakpoint: 'data-collection-grid-item',
    nextPage: 'data-load-btn'
  };
  var loading = false;

  $(selectors.sort).on('click', function (e) {
    sortCollection(this);
  });

  $(selectors.sortSelect).on('change', function (e) {
    sortCollection(this);
  });

  $(selectors.filterOpen).on('click', function (e) {
    $('html').toggleClass('filters-open');
  });

  $(selectors.filterCheck).on('change', function (e) {
    e.preventDefault();
    filter(this);
  });

  $(selectors.btnLoad).on('click', function (e) {
    loadOthers(this);
  });

  $(selectors.viewMin).on('click', function (e) {
    e.preventDefault();
    showView(3, 4);
    $(this).removeClass('disabled');
    $(selectors.viewMax).addClass('disabled');
  });

  $(selectors.viewMax).on('click', function (e) {
    e.preventDefault();
    showView(4, 3);
    $(this).removeClass('disabled');
    $(selectors.viewMin).addClass('disabled');
  });

  scrollBtn();

  if ($(selectors.slider).length) {
    priceSlider();
  }

  function priceSlider() {
    var handlesSlider = document.getElementById('slider');
    var isNewFilter = $(selectors.slider).attr('data-is-new-filter');
    var symbol = $(selectors.slider).attr('data-slider-symbol');
    var min = parseInt($(selectors.slider).attr('data-slider-min'));
    var max = parseInt($(selectors.slider).attr('data-slider-max'));
    var step = parseInt($(selectors.slider).attr('data-slider-step'));
    var actmin = parseInt($(selectors.slider).attr('data-slider-actmin'));
    var actmax = parseInt($(selectors.slider).attr('data-slider-actmax'));

    noUiSlider.create(handlesSlider, {
      start: [actmin, actmax],
      connect: true,
      step: step || 100,
      animate: false,
      tooltips: isNewFilter === 'true'
        ? { to: (value) => ( `€${parseInt(value) / 100}` ) }
        : false,
      range: {
        min,
        max
      }
    });

    handlesSlider.noUiSlider.on('set', function () {
      var vals = slider.noUiSlider.get();
      var valmin = parseInt(vals[0]) / 100;
      var valmax = parseInt(vals[1]) / 100;
      updatePrice(valmin, valmax, isNewFilter);
    });

    handlesSlider.noUiSlider.on('update', function () {
      var vals = slider.noUiSlider.get();
      var valmin = parseInt(vals[0]) / 100;
      var valmax = parseInt(vals[1]) / 100;
      $(selectors.sliderValue).html(symbol + valmin + ' - ' + symbol + valmax);
    });
  }

  function updatePrice(valmin, valmax, isNewFilter) {
    if (isNewFilter === 'true') {
      $('input[name="filter.v.price.gte"]').attr('value', valmin);
      $('input[name="filter.v.price.lte"]').attr('value', valmax);
      return;
    }

    var href = new URL(location.href);
    href.searchParams.set('filter.v.price.gte', valmin);
    href.searchParams.set('filter.v.price.lte', valmax);
    location.href = href;
  }

  function scrollBtn() {
    let callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadOthers($(selectors.btnLoad).first());
        }
      });
    };
    let observer = new IntersectionObserver(callback, {
      threshold: [0.5]
    });

    $(selectors.btnLoad).each(function () {
      observer.observe(this);
    });
  }

  function filter(element) {
    var url = $(element).attr('value');
    location.href = url;
  }

  function sortCollection(element) {
    var value = $(element).attr(attributes.sort) || $(element).val();
    var href = new URL(location.href);
    href.searchParams.set('sort_by', value);
    location.href = href;
  }

  function showView(oldcol, newcol) {
    var breakpoint = $(selectors.gridItem).first().attr(attributes.breakpoint);
    $(selectors.gridItem)
      .removeClass('col-' + breakpoint + '-' + oldcol)
      .addClass('col-' + breakpoint + '-' + newcol);
  }

  function loadOthers(btn) {
    if (!loading) {
      loading = true;
      var url = $(btn).attr(attributes.nextPage);
      $.ajax({
        type: 'GET',
        url: url,
        cache: false,
        contentType: false,
        processData: false,
        success: function (str) {
          var content = $(str).find(selectors.container).html();
          var next = $(str).find(selectors.btnLoad).attr(attributes.nextPage);
          $(selectors.container).append(content);
          if (next != undefined) {
            $(btn).attr(attributes.nextPage, next);
          } else {
            $(btn).remove();
          }
          quickview();
          productCard();
          loading = false;
        },
        error: function (err) {
          console.log(err);
          loading = false;
        }
      });
    }
  }
}

function newAddress() {
  setProvince('#newaddress-country', '#newaddress-province');
  $('#newaddress-country').on('change', function () {
    setProvince(this, '#newaddress-province');
  });
  $('[data-address-country]').each(function () {
    editCountry(this);
  });
  $('[data-remove-address]').on('click', function () {
    removeAddress($(this));
  });

  function removeAddress(btn) {
    var url = $(btn).attr('data-remove-address');
    $.ajax({
      type: 'DELETE',
      url: url,
      success: function (data) {
        location.reload();
      },
      error: function (error) {
        location.reload();
      }
    });
  }

  function editCountry(input) {
    var value = '';
    $(input)
      .find('option')
      .each(function () {
        if (
          $(this).text().localeCompare($(input).attr('data-address-country')) ==
          0
        ) {
          value = $(this).attr('value');
        }
      });
    $(input).val(value);
    var province = $(input).parents('form').find('[data-address-province]');
    setProvince(input, province);
    $(input).on('change', function () {
      setProvince(this, province);
    });
  }

  function setProvince(country, province) {
    var opt = $(country).find('option:selected');
    var provinces = [];
    if ($(opt).attr('data-provinces') != undefined) {
      provinces = JSON.parse($(opt).attr('data-provinces'));
    }
    if (provinces.length > 0) {
      $(province).html('');
      $(province).attr('required', true);
      $(provinces).each(function () {
        var selected =
          $(province).attr('data-address-province') == this[0]
            ? ' selected'
            : '';
        $(province).append(
          '<option value="' +
            this[0] +
            '"' +
            selected +
            '>' +
            this[1] +
            '</option>'
        );
      });
      $(province).parents('[data-form-parent]').removeClass('d-none');
    } else {
      $(province).parents('[data-form-parent]').addClass('d-none');
      $(province).removeAttr('required');
    }
  }
}

function checkCountry() {
  var list = [];
  if ($('#blacklist-quickview').length) {
    var c = $('#blacklist-quickview').html();
  } else if ($('#blacklist').length) {
    var c = $('#blacklist').html();
  }
  if (c != undefined) {
    var json = JSON.parse(c);
    list = json.countries.split(',');
  }
  if (list.length > 0) {
    $.getJSON(
      'https://geolocation-db.com/json/7733a990-ebd4-11ea-b9a6-2955706ddbf3',
      function (result) {
        var red = false;
        $(list).each(function () {
          if (result.country_code == this) {
            red = true;
          }
        });
        if (red) {
          $('[data-blacklist-hide]').remove();
          $('[data-blacklist-show]').removeClass('d-none');
        }
      }
    );
  }
}

function setIubenda() {
  _iub.cons_instructions = _iub.cons_instructions || [];
  _iub.cons_instructions.push([
    'init',
    {
      api_key: iubendaSettings.key
    }
  ]);
}

function popup() {
  $('[data-popup-trigger]').each(function () {
    createPopup(this);
  });

  function createPopup(el) {
    var id = $(el).attr('id');
    var name = id.replace('popup-', '');
    var modal = new bootstrap.Modal(document.getElementById(id), {
      backdrop: 'static',
      keyboard: false
    });
    var percentage = parseInt($(el).attr('data-popup-trigger-scroll'));
    var closed = getCookie('popup-closed');
    var used = getCookie('popup-code');
    var success = $(el).attr('data-popup-success');
    var expireDays = $(el).attr('data-popup-timer');
    var code = $(el).find('[data-copy]').attr('data-copy');

    if (closed == undefined && used == undefined && success == undefined) {
      triggers();
    } else if (used == undefined && success != undefined) {
      saveCode();
    }
    $('[data-popup-close]').on('click', function (e) {
      e.preventDefault();
      closePopup();
    });
    $('[data-copy]').on('click', function () {
      copyText(this);
    });

    function triggers() {
      if ($(el).attr('data-popup-trigger') == 'now') {
        modal.show();
      } else if ($(el).attr('data-popup-trigger') == 'delay') {
        var seconds = parseInt($(el).attr('data-popup-trigger-delay')) * 1000;
        setTimeout(function () {
          modal.show();
        }, seconds);
      } else if ($(el).attr('data-popup-trigger') == 'scroll') {
        window.addEventListener('scroll', showOnScroll);
      } else if ($(el).attr('data-popup-trigger') == 'click') {
        $('[data-popup-open="' + name + '"]').on('click', function () {
          modal.show();
        });
      } else if ($(el).attr('data-popup-trigger') == 'inactivity') {
        onInactive(60 * 1000, function () {
          modal.show();
        });
      } else if ($(el).attr('data-popup-trigger') == 'leave') {
        window.addEventListener('beforeunload', function (e) {
          modal.show();
          e.preventDefault();
          e.returnValue = '';
        });
      }
    }
    function showOnScroll() {
      if (
        $(window).scrollTop() + $(window).height() >=
        ($(document).height() / 100) * percentage
      ) {
        modal.show();
        window.removeEventListener('scroll', showOnScroll);
      }
    }
    function onInactive(ms, cb) {
      var wait = setTimeout(cb, ms);
      document.onmousemove =
        document.mousedown =
        document.mouseup =
        document.onkeydown =
        document.onkeyup =
        document.focus =
          function () {
            clearTimeout(wait);
            wait = setTimeout(cb, ms);
          };
    }
    function closePopup() {
      modal.hide();
      if (expireDays > 0 && used == undefined) {
        setCookie('popup-closed', true, expireDays);
      }
    }
    function copyText(i) {
      var feedbackEl = $(el).parents('form').find('[data-copy-feedback]');
      var feedback = $(feedbackEl).attr('data-copy-feedback');
      var text = $(feedbackEl).text();
      if (!navigator.clipboard) {
        var $temp = $('<input>');
        $('body').append($temp);
        $temp.val(code).select();
        document.execCommand('copy');
        $temp.remove();
      } else {
        navigator.clipboard.writeText(code);
      }
      $(feedbackEl).text(feedback);
      setTimeout(function () {
        $(feedbackEl).text(text);
      }, 3000);
    }
    function saveCode() {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          attributes: {
            discount: code
          }
        },
        cache: false,
        success: function (data) {
          setCookie('popup-code', code, 10000);
          modal.show();
        },
        error: function (error) {
          console.log(error);
        }
      });
    }
  }
}

function filterModal() {
  const _body = $('body');
  const filterModal = document.getElementById('newFilters');
  console.log(filterModal);

  if (filterModal === null) {
    return;
  }

  filterModal.addEventListener('show.bs.modal', () => {
    _body.addClass('gray-backdrop');
  });

  filterModal.addEventListener('hidden.bs.modal', () => {
    _body.removeClass('gray-backdrop');
  });
}

function breadcrumbObserver() {
  const _body = $('body');
  if (document.querySelector('.breadcrumbs-collection') === null) {
    _body.removeClass('block-menu');
    return;
  }

  const observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      _body.addClass('block-menu');
    } else {
      _body.removeClass('block-menu');
    }
  });
  observer.observe(document.querySelector('.breadcrumbs-collection'));
}
